import { AttributeLibraryReadModel } from "@Criteria/Hierarchies/Domain/readmodels";

export class AttributeLibraryViewModel
{
    opened: boolean = false;

    parentId: number | null = null;
    data: AttributeLibraryReadModel | null = null;

    show(parentId: number)
    {
        this.parentId = parentId;
        this.data = null;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.parentId = null;
        this.data = null;
    }

    setData(data: AttributeLibraryReadModel)
    {
        this.data = data;
    }

    setUsed(names: string[])
    {
        const templates = this.data?.CriteriaTemplates.filter(a => names.indexOf(a.Name) > -1) ?? [];
        templates.forEach(a => a.Used = true);
    }
}